// Unpublished Work © 2020-2026 Deere & Company.

export const ADD_MERGE_CUSTOMER_ITEM = 'ADD_MERGE_CUSTOMER_ITEM';
export const REMOVE_ALL_MERGE_CUSTOMER_ITEM = 'REMOVE_ALL_MERGE_CUSTOMER_ITEM';
export const REMOVE_MERGE_CUSTOMER_ITEM = 'REMOVE_MERGE_CUSTOMER_ITEM';
export const RESET_ADD_CUSTOMER_APPLICATION_STATUS = 'RESET_ADD_CUSTOMER_APPLICATION_STATUS';
export const RESET_ADD_CUSTOMER_CONTACT_PHONE = 'RESET_ADD_CUSTOMER_CONTACT_PHONE';
export const RESET_ADD_CUSTOMER_FORM = 'RESET_ADD_CUSTOMER_FORM';
export const RESET_ADD_CUSTOMER_FORM_VALIDATION = 'RESET_ADD_CUSTOMER_FORM_VALIDATION';
export const RESET_ADDRESS = 'RESET_ADDRESS';
export const RESET_CUSTOMER_PROFILE = 'RESET_CUSTOMER_PROFILE';
export const RESET_DATA_SHARE_CONTACT_PHONE = 'RESET_DATA_SHARE_CONTACT_PHONE';
export const RESET_DBS_CUSTOMER_PROFILE = 'RESET_DBS_CUSTOMER_PROFILE';
export const RESET_FACETS_TO_DEFAULTS = 'RESET_FACETS_TO_DEFAULTS';
export const RESET_SAVE_DEFAULT_STATUS = 'RESET_SAVE_DEFAULT_STATUS';
export const RESET_SELECTED_CONTEXT = 'RESET_SELECTED_CONTEXT';
export const RESET_SELECT_BUSINESS_CONTACT = 'RESET_SELECT_BUSINESS_CONTACT';
export const RESET_DBS_CUSTOMER_ADDRESS = 'RESET_DBS_CUSTOMER_ADDRESS';
export const SET_ADD_CUSTOMER = 'SET_ADD_CUSTOMER';
export const SET_ADD_ALL_CUSTOMER_EMAIL_INFO = 'SET_ADD_ALL_CUSTOMER_EMAIL_INFO';
export const SET_ADD_CUSTOMER_EMAIL_INFO = 'SET_ADD_CUSTOMER_EMAIL_INFO';
export const SET_ADD_CUSTOMER_CONTACT_PHONE = 'SET_ADD_CUSTOMER_CONTACT_PHONE';
export const SET_ADD_CUSTOMER_CONTACT_PHONE_ALL = 'SET_ADD_CUSTOMER_CONTACT_PHONE_ALL';
export const SET_ADD_CUSTOMER_DOMAIN_DATA = 'SET_ADD_CUSTOMER_DOMAIN_DATA';
export const SET_ADD_CUSTOMER_PAGE_STATUS = 'SET_ADD_CUSTOMER_PAGE_STATUS';
export const SET_ADD_CUSTOMER_TYPE = 'SET_ADD_CUSTOMER_TYPE';
export const SET_ADDRESS_COUNTRY_CODE = 'SET_ADDRESS_COUNTRY_CODE';
export const SET_ALL_GOVERNMENT_TAX_IDS = 'SET_ALL_GOVERNMENT_TAX_IDS';
export const SET_ALL_PRIVACY_POLICIES = 'SET_ALL_PRIVACY_POLICIES';
export const SET_ASTERISK = 'SET_ASTERISK';
export const SET_BREADCRUMB_TITLE = 'SET_BREADCRUMB_TITLE';
export const SET_BUSINESS_CONTACT = 'SET_BUSINESS_CONTACT';
export const SET_BUSINESS_TAX_DETAILS = 'SET_BUSINESS_TAX_DETAILS';
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_COUNTRY_SELECTION_ERROR = 'SET_COUNTRY_SELECTION_ERROR';
export const SET_COUNTRY_SELECTION_ERROR_ON_DATA_SHARE = 'SET_COUNTRY_SELECTION_ERROR_ON_DATA_SHARE';
export const SET_CROSS_REFERENCE_DATA = 'SET_CROSS_REFERENCE_DATA';
export const SET_CUSTOMER_IDS = 'SET_CUSTOMER_IDS';
export const SET_CUSTOMER_DETAILS_FROM_FACETS = 'SET_CUSTOMER_DETAILS_FROM_FACETS';
export const SET_CUSTOMER_NAME_DETAILS = 'SET_CUSTOMER_NAME_DETAILS';
export const SET_CUSTOMER_DATE_OF_BIRTH = 'SET_CUSTOMER_DATE_OF_BIRTH';
export const SET_SELECTED_ORGANIZATION = 'SET_SELECTED_ORGANIZATION';
export const SET_SELECTED_DBS = 'SET_SELECTED_DBS';
export const SET_US_CTZ_IND = 'SET_US_CTZ_IND';
export const SET_SSN_DETAILS = 'SET_SSN_DETAILS';
export const SET_REGISTRANT_NUMBER_DETAILS = 'SET_REGISTRANT_NUMBER_DETAILS';
export const SET_CUSTOMER_PREFIX_AND_GENERATION_DETAILS = 'SET_CUSTOMER_PREFIX_AND_GENERATION_DETAILS';
export const SET_CUSTOMER_PREFIX_AND_GENERATION_DETAILS_FOR_DBS = 'SET_CUSTOMER_PREFIX_AND_GENERATION_DETAILS_FOR_DBS';
export const SET_CUSTOMER_PROFILE_PAGE_STATUS = 'SET_CUSTOMER_PROFILE_PAGE_STATUS';
export const SET_CUSTOMER_PROFILE_STATUS = 'SET_CUSTOMER_PROFILE_STATUS';
export const SET_CUSTOMER_SEARCH_FACETS = 'SET_CUSTOMER_SEARCH_FACETS';
export const SET_CUSTOMER_SEARCH_ERROR = 'SET_CUSTOMER_SEARCH_ERROR';
export const SET_CUSTOMER_SEARCH_LIST = 'SET_CUSTOMER_SEARCH_LIST';
export const SET_CUSTOMER_SEARCH_PAGE_STATUS = 'SET_CUSTOMER_SEARCH_PAGE_STATUS';
export const SET_CUSTOMER_FILING_DETAILS = 'SET_CUSTOMER_FILING_DETAILS';
export const SET_DBS_ALL_CUSTOMER_EMAIL_INFO = 'SET_DBS_ALL_CUSTOMER_EMAIL_INFO';
export const SET_DBS_CUSTOMER_CONTACT_PHONE = 'SET_DBS_CUSTOMER_CONTACT_PHONE';
export const SET_DBS_CUSTOMER_CONTACT_PHONE_ALL = 'SET_DBS_CUSTOMER_CONTACT_PHONE_ALL';
export const SET_DBS_CUSTOMER_EMAIL_INFO = 'SET_DBS_CUSTOMER_EMAIL_INFO';
export const SET_DBS_CUSTOMER_PROFILE_DATA = 'SET_DBS_CUSTOMER_PROFILE_DATA';
export const SET_DBS_CUSTOMER_PROFILE_MODAL_STATUS = 'SET_DBS_CUSTOMER_PROFILE_MODAL_STATUS';
export const SET_DBS_CUSTOMER_PROFILE_PAGE_STATUS = 'SET_DBS_CUSTOMER_PROFILE_PAGE_STATUS';
export const SET_DBS_EMAIL_NOT_AVAILABLE_CHECK = 'SET_DBS_EMAIL_NOT_AVAILABLE_CHECK';
export const SET_DBS_CUSTOMER_PROFILE_ERROR = 'SET_DBS_CUSTOMER_PROFILE_ERROR';
export const SET_DEFAULT_PREFILLED_FACETS = 'SET_DEFAULT_PREFILLED_FACETS';
export const SET_DOOB_TIGHT_MATCH_MODAL_STATUS = 'SET_DOOB_TIGHT_MATCH_MODAL_STATUS';
export const SET_DROPDOWN_CITIES_PAGE_STATUS = 'SET_DROPDOWN_CITIES_PAGE_STATUS';
export const SET_DUPLICATE_MERGE_CUSTOMER = 'SET_DUPLICATE_MERGE_CUSTOMER';
export const SET_EDIT_CUSTOMER = 'SET_EDIT_CUSTOMER';
export const SET_EMAIL_NOT_AVAILABLE_CHECK = 'SET_EMAIL_NOT_AVAILABLE_CHECK';
export const SET_MIDDLE_NAME_NOT_AVAILABLE_CHECK = 'SET_MIDDLE_NAME_NOT_AVAILABLE_CHECK';
export const SET_CUSTOMER_DETAILS_FROM_FACETS_FLAG = 'SET_CUSTOMER_DETAILS_FROM_FACETS_FLAG';
export const SET_EQUIPMENT_DETAILS = 'SET_EQUIPMENT_DETAILS';
export const SET_EQUIPMENT_DETAILS_TO_DEFAULT = 'SET_EQUIPMENT_DETAILS_TO_DEFAULT';
export const SET_GOVERNMENT_TAX_ID_DETAILS = 'SET_GOVERNMENT_TAX_ID_DETAILS';
export const SET_GOVERNMENT_TAX_ID_TO_DEFAULT = 'SET_GOVERNMENT_TAX_ID_TO_DEFAULT';
export const SET_LOG_HISTORY_DATA = 'SET_LOG_HISTORY_DATA';
export const SET_MAILING_ADDRESS = 'SET_MAILING_ADDRESS';
export const SET_PHYSICAL_ADDRESS = 'SET_PHYSICAL_ADDRESS';
export const COPY_PHYSICAL_TO_MAILING_ADDRESS = 'COPY_PHYSICAL_TO_MAILING_ADDRESS';
export const SET_POTENTIAL_MATCHES = 'SET_POTENTIAL_MATCHES';
export const SET_POTENTIAL_MATCH_CUSTOMER_INFO = 'SET_POTENTIAL_MATCH_CUSTOMER_INFO';
export const SET_POTENTIAL_MATCHES_MODAL_STATUS = 'SET_POTENTIAL_MATCHES_MODAL_STATUS';
export const SET_PREFERRED_LANGUAGE = 'SET_PREFERRED_LANGUAGE';
export const SET_PREFERRED_LANGUAGE_LIST = 'SET_PREFERRED_LANGUAGE_LIST';
export const SET_PREFERRED_LANGUAGE_LIST_STATUS = 'SET_PREFERRED_LANGUAGE_LIST_STATUS';
export const SET_PREFILLED_CUSTOMER_DETAILS = 'SET_PREFILLED_CUSTOMER_DETAILS';
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
export const SET_PROVIDED_PRIVACY_POLICY = 'SET_PROVIDED_PRIVACY_POLICY';
export const SET_SAVE_CUSTOMER_STATUS = 'SET_SAVE_CUSTOMER_STATUS';
export const SET_SAVE_SERVICE_ERROR = 'SET_SAVE_SERVICE_ERROR';
export const FILTER_CONTACTS_BY_CONTACT_ID = 'FILTER_CONTACTS_BY_CONTACT_ID';
export const SET_STATES_OF_SPECIFIC_COUNTRY_STATUS = 'SET_STATES_OF_SPECIFIC_COUNTRY_STATUS';
export const SET_STATES_OF_SPECIFIC_COUNTRY = 'SET_STATES_OF_SPECIFIC_COUNTRY';
export const RESET_REGISTRY_SUCCESS_MESSAGE = 'RESET_REGISTRY_SUCCESS_MESSAGE';
export const RESET_REGISTRY_ERROR_MESSAGE = 'RESET_REGISTRY_ERROR_MESSAGE';
export const SET_DATA_SHARE_SAVE_SUCCESS = 'SET_DATA_SHARE_SAVE_SUCCESS';
export const SET_DBS_SAVE_SERVICE_ERROR = 'SET_DBS_SAVE_SERVICE_ERROR';
export const RESET_DATA_SHARE_SAVE_SUCCESS_MESSAGE = 'RESET_DATA_SHARE_SAVE_SUCCESS_MESSAGE';
export const RESET_DATA_SHARE_SAVE_ERROR_MESSAGE = 'RESET_DATA_SHARE_SAVE_ERROR_MESSAGE';
export const RESET_ALERT_MESSAGES = 'RESET_ALERT_MESSAGES';
export const SET_SEARCH_PREFERENCES = 'SET_SEARCH_PREFERENCES';
export const SET_SEARCH_STARTED = 'SET_SEARCH_STARTED';
export const SET_SELECT_BUSINESS_CONTACT_DATA = 'SET_SELECT_BUSINESS_CONTACT_DATA';
export const SET_SELECT_BUSINESS_CONTACT_PAGE_STATUS = 'SET_SELECT_BUSINESS_CONTACT_PAGE_STATUS';
export const SET_CITY_ADD_EDIT_DROPDOWN = 'SET_CITY_ADD_EDIT_DROPDOWN';
export const SET_CITY_FACET = 'SET_CITY_FACET';
export const SET_CITIES_PAGE_STATUS = 'SET_CITIES_PAGE_STATUS';
export const SET_DBS_CUSTOMER_NAME_DETAILS = 'SET_DBS_CUSTOMER_NAME_DETAILS';
export const SET_DBS_CUSTOMER_PHYSICAL_ADDRESS = 'SET_DBS_CUSTOMER_PHYSICAL_ADDRESS';
export const SET_DBS_CUSTOMER_MAILING_ADDRESS = 'SET_DBS_CUSTOMER_MAILING_ADDRESS';
export const SET_TAX_ID_DETAILS = 'SET_TAX_ID_DETAILS';
export const SET_TAX_ID_NOT_AVAILABLE = 'SET_TAX_ID_NOT_AVAILABLE';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SHOW_EQUIPMENT_ERROR = 'SHOW_EQUIPMENT_ERROR';
export const UPDATE_STATES_AND_ADDRESS_ELEMENTS_IN_SEARCH_FACETS = 'UPDATE_STATES_AND_ADDRESS_ELEMENTS_IN_SEARCH_FACETS';
export const UPDATE_COUNTRY_STATE_LOADING_STATUS = 'UPDATE_COUNTRY_STATE_LOADING_STATUS';
export const UPDATE_COUNTRY_TYPE_FACET = 'UPDATE_COUNTRY_TYPE_FACET';
export const UPDATE_CROSS_REFERENCE_LOADING_STATUS = 'UPDATE_CROSS_REFERENCE_LOADING_STATUS';
export const UPDATE_CUSTOMER_TYPE_FACET = 'UPDATE_CUSTOMER_TYPE_FACET';
export const UPDATE_DOOB_INDICATOR = 'UPDATE_DOOB_INDICATOR';
export const UPDATE_FULL_PAGE_LOADING_STATUS = 'UPDATE_FULL_PAGE_LOADING_STATUS';
export const UPDATE_INPUT_TYPE_FACET = 'UPDATE_INPUT_TYPE_FACET';
export const UPDATE_LOG_HISTORY_LOADING_STATUS = 'UPDATE_LOG_HISTORY_LOADING_STATUS';
export const UPDATE_MEMBERSHIP = 'UPDATE_MEMBERSHIP';
export const UPDATE_MERGE_CUSTOMER_COMMENTS = 'UPDATE_MERGE_CUSTOMER_COMMENTS';
export const UPDATE_MERGE_CUSTOMER_MODAL_STATUS = 'UPDATE_MERGE_CUSTOMER_MODAL_STATUS';
export const UPDATE_MERGE_CUSTOMER_STATUS = 'UPDATE_MERGE_CUSTOMER_STATUS';
export const UPDATE_MULTIPLE_INPUT_TYPE_FACETS = 'UPDATE_MULTIPLE_INPUT_TYPE_FACETS';
export const UPDATE_CUSTOMER_ORG_SELECTION = 'UPDATE_CUSTOMER_ORG_SELECTION';
export const UPDATE_PRIMARY_MERGE_CUSTOMER = 'UPDATE_PRIMARY_MERGE_CUSTOMER';
export const UPDATE_PROFILE_MEMBERSHIP = 'UPDATE_PROFILE_MEMBERSHIP';
export const UPDATE_PROFILE_ORGANIZATION = 'UPDATE_PROFILE_ORGANIZATION';
export const UPDATE_SEARCH_PREFERENCES_AFTER_SAVE = 'UPDATE_SEARCH_PREFERENCES_AFTER_SAVE';
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const UPDATE_SEARCH_VIEW_RESULTS_BUTTON_VISIBILITY = 'UPDATE_SEARCH_VIEW_RESULTS_BUTTON_VISIBILITY';
export const UPDATE_CITY_ADD_EDIT_DROPDOWN = 'UPDATE_CITY_ADD_EDIT_DROPDOWN';
export const UPDATE_CITIES_FACET = 'UPDATE_CITIES_FACET';
export const UPDATE_STATES_FACET = 'UPDATE_STATES_FACET';
export const UPDATE_UNIQUE_INPUT_TYPE_FACET = 'UPDATE_UNIQUE_INPUT_TYPE_FACET';
export const UPDATE_CONFIRMATION_MODAL_STATUS = 'UPDATE_CONFIRMATION_MODAL_STATUS';
export const UPDATE_REASON_CAPTURE_FORM_STATUS = 'UPDATE_REASON_CAPTURE_FORM_STATUS';
export const REDIRECT_USER_TO_SEARCH_SCREEN = 'REDIRECT_USER_TO_SEARCH_SCREEN';
export const REDIRECT_USER_TO_PROFILE_SCREEN = 'REDIRECT_USER_TO_PROFILE_SCREEN';
export const UPDATE_MERGE_REQUEST_FULL_PAGE_LOADER_SHOWN = 'UPDATE_MERGE_REQUEST_FULL_PAGE_LOADER_SHOWN';
export const FILTER_CUSTOMER_SEARCH_BY_CONTACT_ID = 'FILTER_CUSTOMER_SEARCH_BY_CONTACT_ID';
export const FILTER_CUSTOMER_SEARCH_BY_ENTITY_ID = 'FILTER_CUSTOMER_SEARCH_BY_ENTITY_ID';
export const SET_REMOVE_VISIBILITY_ERROR = 'SET_REMOVE_VISIBILITY_ERROR';
export const SET_CUSTOMER_VISIBILITY_REMOVED_STATUS = 'SET_CUSTOMER_VISIBILITY_REMOVED_STATUS';
export const SET_DELETE_CONTACTS_SUCCESS_MESSAGE_SHOWN = 'SET_DELETE_CONTACTS_SUCCESS_MESSAGE_SHOWN';
export const SET_DELETE_CONTACTS_SUCCESS_COUNTS = 'SET_DELETE_CONTACTS_SUCCESS_COUNTS';
export const SET_DELETE_CONTACT_FLOW_ACTIVE = 'SET_DELETE_CONTACT_FLOW_ACTIVE';
export const HANDLE_DELETE_CONTACT_CHECKBOX_CHANGE = 'HANDLE_DELETE_CONTACT_CHECKBOX_CHANGE';
export const RESET_DELETE_CONTACT_FLOW = 'RESET_DELETE_CONTACT_FLOW';
export const SET_DELETE_CONTACT_WARNING_MODAL_VISIBLE = 'SET_DELETE_CONTACT_WARNING_MODAL_VISIBLE';
export const SET_MERGE_CONTACT_FLOW_ACTIVE = 'SET_MERGE_CONTACT_FLOW_ACTIVE';
export const HANDLE_MERGE_CONTACT_CHECKBOX_CHANGE = 'HANDLE_MERGE_CONTACT_CHECKBOX_CHANGE';
export const RESET_MERGE_CONTACT_FLOW = 'RESET_MERGE_CONTACT_FLOW';
export const SET_INITIAL_MERGE_CONTACT_ID = 'SET_INITIAL_MERGE_CONTACT_ID';
